import Vue from "vue";
import Owner from "@/model/cospirit-api/Owner";
import BudgetRepository from "@/repositories/budget/BudgetRepository";
import _ from "lodash";

export interface Budget {
    label: string;
    beginDate: string;
    endDate: string;
    amount: number;
    amountIncludingTax: number;
    consumedAmountAggregate: number;
    owner: Owner;
    uuid: string;
}

export default {
    state: {
        budgets: [],
    },
    mutations: {
        setBudgets: (state: any, budgets: Budget[]) => {
            Vue.set(state, "budgets", budgets);
        },
    },
    getters: {
        getBudgets: (state: any): Budget[] => {
            return state.budgets;
        },
        getBudget: (state: any) => (uuid: string): Budget | undefined => {
            return _.find(state.budgets, (budget: Budget) => {
                return _.get(budget, "uuid", null) === uuid;
            });
        },
    },
    actions: {
        loadBudgets: ({commit}: any) => {
            BudgetRepository.get().then((data: any) => {
                commit("setBudgets", data);
            });
        },
    },
};
